import * as S from "./styled";
import logo from "../../assets/Svg/icon.svg";
import React from "react";
import theme from "../../theme";
import { useTranslation } from 'react-i18next';

export default function ServiceTerms() {
    const { t } = useTranslation();

    return (
        <S.Container>
            <S.Logo src={logo} alt="logo" />

            <S.SubContainer>
                <a style={{ color: theme.COLORS.PRIMARY }} href="/">{t('service_terms_back')}</a>
                <S.Title>
                    {t('service_terms_title')}
                </S.Title>
                <S.Description>
                    {t('service_terms_description_1')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_2')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_3')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_4')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_5')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_6')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_7')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_8')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_9')}
                </S.Description>
                <S.Description>
                    {t('service_terms_description_10')}
                </S.Description>
            </S.SubContainer>
        </S.Container>
    );
}
